<template>
  <v-card>
    <v-card-title class="align-center justify-center primary white--text mb-4">Mettre à jour le stock</v-card-title>
    <v-card-text>
      <div class="d-flex flex-column">
        <div>
          <p><b>Stock maximum du contrat:</b> {{ initialStock }} </p>
          <p><b>Stock contractuel actuel:</b> {{ auxContract.remainingStock }} </p>
          <p><b>Solde actuel des stocks:</b> {{ auxContract.remainingStockMinusReservations }} ({{ reservationQuantity }} réservation future)</p>
        </div>
        <v-text-field v-model="newStockQuantity" label="Nouvelle quantité de stock" :rules="stockInputRules" style="width: 50%;" />
        <v-textarea v-model="observation" outlined no-resize label="Observations" style="width: 100%;" />
      </div>
      <v-col class="d-flex justify-center">
        <v-btn width="200" color="primary" :disabled="!isInputValid || !newStockQuantity || !observation" :loading="loading" @click="confirm">
          <span class="d-none d-sm-inline-block">Enregistrer</span>
        </v-btn>
      </v-col>
    </v-card-text>
  </v-card>
</template>
<script>
import { requests, EventBus } from '@/mixins/index';

export default {
  components: { },
  mixins: [requests],
  props: {
    contract: {
      type: Object,
      default: () => {}
    },
    customer: {
      type: Object,
      default: () => {}
    },
    initialStock: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      newStockQuantity: null,
      observation: null,
      stockInputRules: [
        v => !v || !this.initialStock || v <= this.initialStock || 'Impossible de définir plus de stock que celui initialement défini.',
        v => !v || !this.auxContract || v >= this.reservationQuantity || 'Ne peut pas définir un stock inférieur au nombre de réservations futures.'
      ],
      loading: false,
      auxContract: this.$props.contract
    };
  },
  computed: {
    reservationQuantity () {
      return this.auxContract ? this.auxContract.remainingStock - this.auxContract.remainingStockMinusReservations : null;
    },
    isInputValid () {
      return this.stockInputRules.every(rule => rule(this.newStockQuantity) === true);
    }
  },
  methods: {
    async confirm () {
      if (!this.newStockQuantity || parseInt(this.newStockQuantity) > this.initialStock || parseInt(this.newStockQuantity) < this.reservationQuantity) {
        return;
      }
      this.loading = true;
      const response = await this.changeContractStockBalance(this.$props.customer.uuid, this.auxContract.contractNumber, this.auxContract.remainingStock, parseInt(this.newStockQuantity), this.$store.state.user.uuid, this.observation);
      this.loading = false;

      const notification = {
        message: response.success ? 'Mise à jour des stocks réussie' : 'Erreur de mise à jour du stock',
        type: response.success ? 'success' : 'danger',
        timeout: 10000
      };

      EventBus.$emit('show-notifications', [notification]);

      if (response.success && response.data) {
        EventBus.$emit('update-stock', { ...response.data, remainingStockMinusReservations: parseInt(this.newStockQuantity) - this.reservationQuantity });
        this.auxContract = { ...this.auxContract, remainingStock: this.newStockQuantity, remainingStockMinusReservations: parseInt(this.newStockQuantity) - this.reservationQuantity };
        EventBus.$emit('up-to-date-contract-history', false);
        this.newStockQuantity = null;
        this.observation = null;
      }
    }
  }
};
</script>
